
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"120","height":"120"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.25 106.62V89.29c0-29.08 22.75-52.67 50.87-52.67S103 60.21 103 89.29v17.33","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M17 106.62V89.29c0-29.08 22.77-52.67 50.86-52.67s50.87 23.59 50.87 52.67v17.33","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M53.02 66.63v-7h13.96v7.07M86.33 67.52l-8.56 8.58H42.01l-8.34-8.36M53.02 76.1v14.67M66.98 76.1v14.67M6.18 67.64h107.66M94.36 90.75l-.08 14.88H25.64V90.75h68.72z"}})])
          )
        }
      }
    